module.exports = __webpack_public_path__ + "img/w2w-transfer.3e1a1f6f.png";